import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(({ spacing, typography }) => ({
    agent: {
        margin: spacing(0),
        fontWeight: typography.fontWeightRegular
    }
}));
